import { SELF_SERVICE_STATUS } from 'constants/StatisticsConstants';
import * as types from 'modules/statistics/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {string} */
const initialState = SELF_SERVICE_STATUS;

const set = (_, { payload }) => payload;

export default createReducer(initialState, {
  [types.SET_SELECTED_SELF_SERVICE_TAB]: set,
});
